export const apiKey = process.env.VUE_APP_FILESTACK_API_KEY || 'AfpPhIgiRTwmDLBPgCnO1z'